import { Language } from '../models';

export const DEFAULT_LANGUAGE: string = Language.Croatian;
